import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {Item} from './item';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  @Input() items: { [key: string]: Item };
  @Input() itemKeys: string[];
  @Output() switchPartlySupportedFeatures: EventEmitter<boolean> = new EventEmitter();
  displayType: string;
  partlySupportedFeatures: boolean;

  constructor() {
  }

  setDisplayType(type: string) {
    this.displayType = type;
  }

  setPartlySupportedFeatures(value: boolean) {
    this.partlySupportedFeatures = value;
    this.switchPartlySupportedFeatures.emit(this.partlySupportedFeatures);
  }

  ngOnInit() {
    this.displayType = 'column';
    this.partlySupportedFeatures = false;
  }
}
